// import { Controller } from "stimulus"
import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  connect(){
    window._topicView = new TopicView({parentView: this.element});
  }
}
